
import React, { useState } from 'react';
import './CalendarPage.css';
import PageHeader from '../../components/shared/PageHeader';
import Card from '../../components/shared/Card';
import Button from '../../components/shared/Button';
import Badge from '../../components/shared/Badge';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

const SAMPLE_EVENTS: Record<number, { title: string; type: string }[]> = {
  5: [{ title: 'Team Standup', type: 'call' }],
  12: [{ title: 'Client Review', type: 'meeting' }, { title: 'Product Demo', type: 'call' }],
  18: [{ title: 'Analytics Review', type: 'meeting' }],
  24: [{ title: 'Lunch with Sarah', type: 'personal' }],
  27: [{ title: 'Sprint Planning', type: 'meeting' }],
};

export default function CalendarPage() {
  const today = new Date();
  const [month, setMonth] = useState(today.getMonth());
  const [year, setYear] = useState(today.getFullYear());

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cells: (number | null)[] = [...Array(firstDay).fill(null), ...Array.from({ length: daysInMonth }, (_, i) => i + 1)];
  while (cells.length % 7 !== 0) cells.push(null);

  const prevMonth = () => { if (month === 0) { setMonth(11); setYear(y => y - 1); } else setMonth(m => m - 1); };
  const nextMonth = () => { if (month === 11) { setMonth(0); setYear(y => y + 1); } else setMonth(m => m + 1); };

  return (
    <div className="calendar-page">
      <PageHeader
        title="Calendar"
        breadcrumb={['Business', 'Calendar']}
        actions={<Button size="sm" icon="+">New Event</Button>}
      />
      <div className="calendar-layout">
        <Card className="calendar-mini-sidebar">
          <div className="mini-cal-header">
            <button className="mini-cal-nav" onClick={prevMonth}>‹</button>
            <span>{MONTHS[month].slice(0,3)} {year}</span>
            <button className="mini-cal-nav" onClick={nextMonth}>›</button>
          </div>
          <div className="mini-cal-grid">
            {DAYS.map(d => <div key={d} className="mini-cal-day-header">{d[0]}</div>)}
            {cells.map((day, i) => (
              <div key={i} className={`mini-cal-day${day === today.getDate() && month === today.getMonth() ? ' mini-cal-day--today' : ''}${day && SAMPLE_EVENTS[day] ? ' mini-cal-day--has-event' : ''}`}>{day}</div>
            ))}
          </div>
          <div className="upcoming-header">Upcoming</div>
          {[5,12,18].map(d => SAMPLE_EVENTS[d]?.[0] && (
            <div key={d} className="upcoming-item">
              <span className="upcoming-date">{MONTHS[month].slice(0,3)} {d}</span>
              <span className="upcoming-title">{SAMPLE_EVENTS[d][0].title}</span>
            </div>
          ))}
        </Card>
        <Card className="calendar-main" noPad>
          <div className="cal-header">
            <button className="mini-cal-nav" onClick={prevMonth}>‹</button>
            <h2 className="cal-month-title">{MONTHS[month]} {year}</h2>
            <button className="mini-cal-nav" onClick={nextMonth}>›</button>
          </div>
          <div className="cal-grid-header">{DAYS.map(d => <div key={d} className="cal-grid-day-name">{d}</div>)}</div>
          <div className="cal-grid">
            {cells.map((day, i) => (
              <div key={i} className={`cal-cell${!day ? ' cal-cell--empty' : ''}${day === today.getDate() && month === today.getMonth() ? ' cal-cell--today' : ''}`}>
                {day && (
                  <>
                    <span className="cal-cell-num">{day}</span>
                    <div className="cal-events">
                      {(SAMPLE_EVENTS[day] || []).map((ev, ei) => (
                        <div key={ei} className={`cal-event cal-event--${ev.type}`}>{ev.title}</div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
